// extracted by mini-css-extract-plugin
module.exports = {"root":"Arrow-root-CdFJ8","colorDark":"Arrow-colorDark-drwjR"};